import '@descope-ui/descope-combo-box';
import '@descope-ui/descope-button';

import { componentName, CalendarClass } from './CalendarClass';

customElements.define(componentName, CalendarClass);

export { CalendarClass, componentName };
